<template>
  <div>
    <el-dropdown trigger="hover">
      <div class="avatar-content nav-bar-item ml12">
        <img class="icon" :src="avatar16" alt="">
        <span class="user-name">{{ `${userInfo.userName}（${userInfo.roleList[0].name}）` || "" }}</span>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown-content">
        <BLMCard :btnList="btnList">
          <template #titleBox>
            <img class="icon" :src="avatar40" alt="">
            <span class="user-name">{{ `${userInfo.userName}（${userInfo.roleList[0].name}）` || "" }}</span>
          </template>
          <template #infoBox>
            <div class="item" v-if="userInfo.userAccount">
              <div class="title">
                <i class="icon BLM-icon-account" />
                <span class="label">{{ userInfo.userAccount }}</span>
              </div>
            </div>
            <div class="item" v-if="userInfo.userMobile">
              <div class="title">
                <i class="icon BLM-icon-phone" />
                <span class="label">{{ userInfo.userMobile }}</span>
              </div>
            </div>
            <div class="item other-item" @click="handleModifyPwd">
              <div class="title">
                <i class="icon BLM-icon-lock" />
                <span class="label">修改密码</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
          <template #customBox>
              <div class="sys-version" v-if="sysVersion">系统版本号{{ sysVersion }}</div>
          </template>
        </BLMCard>
      </el-dropdown-menu>
    </el-dropdown>
    <modifyPwd :modifyPwdVisible="modifyPwdVisible" @updateVisible="handlerUpdateVisible">
    </modifyPwd>
  </div>
</template>
<script>
import avatar16 from '../assets/avatar-16.png'
import avatar40 from '../assets/avatar-40.png'
import BLMCard from '@/components/BLMCard/index.vue'
import modifyPwd from './modifyPwd.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BLMCard,
    modifyPwd,
  },
  props: {

  },
  computed: {
    ...mapGetters(['userInfo', 'pathnames']),
  },
  data() {
    return {
      avatar16,
      avatar40,
      modifyPwdVisible: false,
      sysVersion: '',
      btnList: [
        {
          type: 'confirm',
          text: '退出登录',
          event: this.logout,
          style: {
            width: '100%',
          },
        },
      ],
    }
  },
  mounted() {
  },
  methods: {
    handleModifyPwd() {
      this.modifyPwdVisible = true
    },
    handlerUpdateVisible(state) {
      this.modifyPwdVisible = state
    },
    logout() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
          setTimeout(() => {
            sessionStorage.removeItem('oldStartIndex')
          }, 10)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录',
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.avatar-content {
  padding: 6px 8px;
  display:flex;
  align-items: center;
  .icon {
      font-size: 16px;
      margin-right: 10px;
  }
}

.user-dropdown-content {
  width: 260px;
  padding:0px;
  border-radius: 8px;
  .title-box {
      display: flex;
      align-items: center;

      .icon {
          font-size: 40px;
          margin-right: 6px;
      }
  }

  .item {
      padding: 4px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
          .icon {
              margin-right: 5px;
          }

          .label {
              color: rgba(0, 0, 0, 0.7);
              white-space: nowrap;
          }
      }
  }

  .other-item {
      cursor: pointer;
  }

  .sys-version {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.3);
      text-align: center;
  }
}
</style>
